<template>
    <div :class="menuListClass">
        <template v-for="m in menuList">
            <hr v-if="m.split" class="ur-lnb__menu-divider" color="#eaeaea"/>
            <div :class="menuClass(m)" @click="clickMenu(m)">
                <span>{{m.name}}</span>
                <ur-icon-wrapper class="fold-icon">
                    <ur-icon type="picto">collapse_menu</ur-icon>
                </ur-icon-wrapper>
            </div>
            <ur-lnb-menu-list v-if="m.hasChild" :menu-list="m.children" :depth="depth+1" :keyword="keyword"/>
        </template>
    </div>
</template>


<script>
    // ur-lnb-menu-list 는 화면의 LNB 영역에서, 메뉴를 구성하는 컴포넌트입니다.
    // 설정에 따라 depth를 가진 menu를 구성할 수 있습니다.
    // #ur-lnb-menu-list is a component that composes a menu in the LNB area of ​​the screen.
    // #Depending on the settings, you can configure a menu with depth.
export default {
    name: 'ur-lnb-menu-list',
    data() {return{}},
    props: {
        // $ver: v0.2.0
        // 현재 메뉴의 깊이(depth)를 명시합니다.
        // #Depth of the current menu.
        depth: Number,
        // $ver: v0.2.0
        // 컴포넌트의 메뉴 리스트입니다.
        // #This property specifies the menu list of the component.
        menuList: Array,
        // $ver: v0.2.0
        // LNB의 상단 검색기능(필터)을 위한 값입니다.
        // #This is the value for the upper search feature(filter) of the LNB.
        keyword : String
    },
    inject: ['side'],
    computed: {
        menuListClass() {
            return [
                'ur-lnb__menu-list',
                'ur-lnb__menu-list--depth-'+this.depth
            ]
        },
        isFilter() {
            return !!this.keyword;
        },
        kw() {
            if( this.isFilter ) {return this.keyword.toLowerCase();}
            return "";
        }
    },
    methods:{
        menuClass(m) {
            let clazz = [];
            let foldable = m.hasChild;
            let selected = (m.url === this.side.currUri);

            clazz.push('ur-lnb__menu');
            if(selected) {clazz.push('ur-lnb__menu--selected');}
            if(foldable) {clazz.push('ur-lnb__menu--foldable')}
            if(m.fold) {clazz.push('ur-lnb__menu--fold')}
            if( this.isFilter ) {
                clazz.push('ur-lnb__menu--filtered');
                let lb = m.name.toLowerCase();
                if(!!this.kw && lb.match(this.kw)) {
                    clazz.push('ur-lnb__menu--matched');
                } else if(!foldable && !selected) {
                    clazz.push('ur-lnb__menu--bluered');
                }
            }
            return clazz;
        },
        clickMenu(m) {
            if(m.hasChild) {
                m.fold = !m.fold;
                this.$forceUpdate();
            }
            if(m.url) {
                this.side.moveMenu(m.url);
            } else if(m.children && Array.isArray(m.children)){
                this.clickMenu(m.children[0]);
            } else {
                return;
            }

        },
    }
}
</script>
